<template>
    <section class="">
      <b-row class="">
        <!-- Col: Left (Invoice Container) -->
        <b-col cols="12" xl="12" md="12">
          <b-card-actions action-collapse title="Detailed quotation">
            <b-row class="">
              <b-col cols="12" xl="12" md="12" class="mt-15">
              <h5>Reference</h5>
            </b-col>
            <b-col
              lg="12"
              md="12"
              sm="12"
              xs="12"
              cols="12"
            >
              <b-form-group label-for="reference">
                <b-form-input
                  v-model="form.reference"
                  placeholder="Reference"
                  required
                  class="input-outline-bleu-border"
                  :readonly="true"
                ></b-form-input>
              </b-form-group>
            </b-col>

              <b-col cols="12" xl="12" md="12">
                <h5>Client</h5>
              </b-col>
              <b-col cols="12" xl="12" md="12">
                <b-form-input
                  id="item-from"
                  v-model="form.customer"
                  label="title"
                  placeholder="Client"
                  :readonly="true"
                />
              </b-col>
  
              <b-col cols="12" xl="12" md="12" class="mt-30">
                <h5>Route</h5>
              </b-col>
              <b-col cols="12" xl="6" md="6">
                <b-form-input
                  id="item-from"
                  v-model="form.loadingPort"
                  label="title"
                  placeholder="From"
                  :readonly="true"
                />
              </b-col>
              <b-col cols="12" xl="6" md="6">
                <b-form-input
                  id="item-To"
                  v-model="form.dischargePort"
                  label="title"
                  placeholder="To"
                  :readonly="true"
                />
              </b-col>
  
              <b-col cols="12" xl="12" md="12" class="mt-15">
                <b-form-input
                  id="item-Incoterm"
                  v-model="form.incoterm"
                  label="item-Incoterm"
                  placeholder="Incoterm"
                  :readonly="true"
                />
              </b-col>
              <b-col
                lg="6"
                md="6"
                sm="6"
                xs="6"
                cols="12"
                class="mt-15"
                v-if="form.incoterm == 'EXW' || form.incoterm == 'FCA'"
              >
                <b-form-group label-for="Incoterm">
                  <b-form-input
                    id="Incoterm"
                    v-model="form.transportType"
                    class="input-outline-bleu-border"
                    placeholder="Transport Type"
                    :readonly="true"
                 />
                </b-form-group>
              </b-col>
  
              <b-col
                lg="6"
                md="6"
                sm="6"
                xs="6"
                cols="12"
                class="mt-15"
                v-if="
                  form.transportType == 'Transport Marchant' &&
                  (form.incoterm == 'EXW' || form.incoterm == 'FCA')
                "
              >
                <b-form-group label-for="departureAddressCity">
                  <b-form-input
                    v-model="form.departureAddressCity"
                    placeholder="Adresse Depart City"
                    :readonly="true"
                    class="input-outline-bleu-border"
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col
                lg="6"
                md="6"
                sm="6"
                xs="6"
                cols="12"
                class="mt-15"
                v-if="form.incoterm == 'DAP'"
              >
                <b-form-group label-for="Incoterm">
                  <b-form-input
                    id="Incoterm"
                    v-model="form.transportType"
                    :options="TransportLoadingOptions"
                    :readonly="true"
                    class="input-outline-bleu-border"
                    placeholder="Transport Type"
                  />
                </b-form-group>
              </b-col>
  
              <b-col
                lg="6"
                md="6"
                sm="6"
                xs="6"
                cols="12"
                class="mt-15"
                v-if="
                  form.transportType == 'Transport Marchant' &&
                  form.incoterm == 'DAP'
                "
              >
                <b-form-group label-for="arrivalAddressCity">
                  <b-form-input
                    v-model="form.arrivalAddressCity"
                    placeholder="adresse Arrival City"
                    :readonly="true"
                    class="input-outline-bleu-border"
                  ></b-form-input>
                </b-form-group>
              </b-col>
  
              <b-col cols="12" xl="12" md="12" class="mt-30">
                <h5>Commodity</h5>
              </b-col>
              <b-col cols="12" xl="12" md="12">
                <b-form-input
                  id="item-Commodity"
                  v-model="form.commodity"
                  label="title"
                  placeholder="Commodity"
                  :readonly="true"
                />
              </b-col>
              <b-col cols="12" xl="12" md="12" class="mt-15">
                <b-form-group>
                                              <b-form-radio-group v-model="selectedOption" class="commodity-radio-group" :disabled="true">
                                                  <!--<b-form-radio value="radio1">
                                                    Peperishable cargo requiring temperature control
                                                  </b-form-radio>-->
                                                  <b-form-radio value="radio2">
                                                    Cargo requiring special equipment
                                                  </b-form-radio>
                                                  <b-form-radio value="radio3">
                                                    Dangerous Cargo
                                                  </b-form-radio>
                                              </b-form-radio-group>
                                              </b-form-group> 
  
              </b-col>
              <!--<b-col lg="4" md="4" sm="6" xs="12" cols="12" v-if="selectedOption==='radio1'">
                                              <b-form-group>
                                                  <b-form-input
                                                  id="temperature"
                                                  placeholder="Temperature"
                                                  v-model="form.TemperatureControl"
                                                  :readonly="true"
                                                  class="input-outline-bleu-border"
                                                  ></b-form-input>
                                              </b-form-group>
                                          </b-col>-->
              <b-col lg="4" md="4" sm="6" xs="12" cols="12" v-if="selectedOption==='radio2'">
                                              <b-form-group>
                                                  <b-form-input
                                                  id="height"
                                                  placeholder="Height"
                                                  v-model="form.specialEquipment.height"
                                                  :readonly="true"
                                                  class="input-outline-bleu-border"
                                                  ></b-form-input>
                                              </b-form-group>
                                          </b-col>
                                          <b-col lg="4" md="4" sm="6" xs="12" cols="12" v-if="selectedOption==='radio2'">
                                              <b-form-group>
                                                  <b-form-input
                                                  id="width"
                                                  placeholder="Width"
                                                  v-model="form.specialEquipment.width"
                                                  :readonly="true"
                                                  class="input-outline-bleu-border"
                                                  ></b-form-input>
                                              </b-form-group>
                                          </b-col> 
                                          <b-col lg="4" md="4" sm="6" xs="12" cols="12" v-if="selectedOption==='radio2'">
                                              <b-form-group>
                                                  <b-form-input
                                                  id="length"
                                                  placeholder="Length"
                                                  v-model="form.specialEquipment.length"
                                                  :readonly="true"
                                                  class="input-outline-bleu-border"
                                                  ></b-form-input>
                                              </b-form-group>
                                          </b-col> 
              <b-col lg="6" md="6" sm="6" xs="12" cols="12" v-if="selectedOption==='radio3'">
                <b-form-group label-for="classe">
                  <b-form-input
                    id="classe"
                    v-model="form.commodityClass"
                    label="title"
                    required
                    placeholder="classe"
                    :readonly="true"
                    class="input-outline-bleu-border"
                  />
                </b-form-group>
              </b-col>
              <b-col lg="6" md="6" sm="6" xs="12" cols="12" v-if="selectedOption==='radio3'">
                <b-form-group label-for="un">
                  <b-form-input
                    id="un"
                    v-model="form.commodityUn"
                    :readonly="true"
                    placeholder="UN"
                    required
                    label="title"
                    class="input-outline-bleu-border"
                  />
                </b-form-group>
              </b-col>
              <b-col cols="12" xl="12" md="12" class="mt-30">
                <h5>Container</h5>
              </b-col>
  <b-col cols="12" xl="12" md="12">
              <b-row v-for="(item, index) in form.containers" :key="index">
                <b-col  lg="4" md="4" sm="6" xs="12" cols="12">
                  <b-form-group label-for="container">
                    <b-form-input
                      id="container"
                      v-model="item.containerType"
                      required
                      label="title"
                      placeholder="Container type"
                      class="input-outline-bleu-border"
                      :readonly="true"
                    />
                  </b-form-group>
  
                  <b-form-group >
                    <b-form-checkbox value="true" v-model="item.isOwnedByShipper" :disabled="true"
                      >Shipper owned container</b-form-checkbox
                    >
                  </b-form-group>
                </b-col>
                <b-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <b-form-group
                    label-for="Container-qte"
                  >
                    <b-form-spinbutton
                      id="Container-qte"
                      v-model="item.quantity"
                      min="1"
                      max="100000"
                      :readonly="true"
                      class="input-outline-bleu-border"
                    ></b-form-spinbutton>
                  </b-form-group>
                </b-col>
                <b-col lg="4" md="4" sm="6" xs="12" cols="12">
                  <b-form-group
                    label-for="Container-quantity"
                  >
                    <b-form-input
                      placeholder="Container weight ( kg )"
                      v-model="item.weight"
                      :readonly="true"
                      required
                      id="Container-quantity"
                      disable
                      class="input-outline-bleu-border"
                    ></b-form-input>
                  </b-form-group>
                </b-col>
              </b-row>
               </b-col>
  
                <b-col cols="12" xl="12" md="12" class="mt-30">
                <h5>Date</h5>
              </b-col>
              <b-col cols="12" xl="6" md="6" >
                  <b-form-datepicker
                    id="Effective-datepicker"
                    v-model="form.effectiveDate"
                    class="mb-1"
                    placeholder="Effective date"
                    :readonly="true"
                  />
              </b-col>
              <b-col cols="12" xl="6" md="6" >
                      <b-form-datepicker
                        id="Expiry-datepicker"
                        v-model="form.expiryDate"
                        class="mb-1"
                        placeholder="Expiry date"
                        :readonly="true"
                      />
              </b-col>
            </b-row>
          </b-card-actions>
        </b-col>
      </b-row>
    </section>
  </template>

<script>
import Logo from "@core/layouts/components/Logo.vue";
import { heightTransition } from "@core/mixins/ui/transition";
import Ripple from "vue-ripple-directive";
import BCardActions from "@core/components/b-card-actions/BCardActions.vue";

import {
  BRow,
  BCol,
  BCard,
  BCardBody,
  BButton,
  BCardText,
  BForm,
  BFormGroup,
  BFormInput,
  BInputGroup,
  BInputGroupPrepend,
  BFormTextarea,
  BFormCheckbox,
  BPopover,
  VBToggle,
  BFormSpinbutton,
  BFormDatepicker,
  BFormRadioGroup,
  BFormRadio
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import SidebarAddNewCustomer from "../../composants/sidebar/SidebarAddNewCustomer.vue";
import SidebarAddNewAgency from "../../composants/sidebar/SidebarAddNewAgency.vue";
import SidebarAddNewCommodity from "../../composants/sidebar/SidebarAddNewCommodity.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import axios from "@axios";

export default {
  components: {
    BFormDatepicker,
    BFormSpinbutton,
    BCardActions,
    BRow,
    BCol,
    BCard,
    BCardBody,
    BButton,
    BCardText,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BFormTextarea,
    BFormCheckbox,
    BPopover,
    flatPickr,
    vSelect,
    Logo,
    SidebarAddNewCustomer,
    SidebarAddNewAgency,   
    SidebarAddNewCommodity,
    ToastificationContent,
    BFormRadioGroup,
    BFormRadio
  },
  data() {
    return {
        form: {
        customer: null,
        arrivalPortAgent: null,
        departurePortAgent: null,
        loadingPort: null,
        dischargePort: null,
        incoterm:null,
        transportType:null,
        departureAddressCity:null,
        TransportDischarge:null,
        arrivalAddressCity:null,
        commodity: null,
        requiresTemperatureControl: false,
        requiresSpecialEquipment:false,
        dangerousCargo:false,
        TemperatureControl: null,
        commodityClass: null,
        commodityUn: null,
        specialEquipment : {
          height: null,
          width: null,
          length: null,
        },
        containers: [
          {
            containerType: null,
            quantity: 1,
            weight: '1000.000',
            isOwnedByShipper: false,
          }
        ],
        effectiveDate: null,
        expiryDate: null,
      },
      selectedOption : null, 
    }
},
    created() {
        this.getQuotation()
    },
    methods: {
        async getQuotation() {
        const response = await axios.get(
            "https://mtl-feeder-nodejs.onrender.com/api/quotations?id="+this.$router.history.current.query.id
        );
        this.form=response.data.data
        this.form.customer= this.form.customer.customer.firstName + " " + this.form.customer.customer.lastName
            if (this.form.requiresTemperatureControl) {
                this.selectedOption = "radio1"
            }
            if (this.form.requiresSpecialEquipment) {
                this.selectedOption = "radio2"
            }
            if (this.form.dangerousCargo) {
                this.selectedOption = "radio3"
            }
        },
    }
}
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
.commodity-radio-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}
</style>
